module.exports = __webpack_public_path__ + "img/68ABITO-ARIA-SML-RIC.GRECIA-RIC.LIMONE2copia.38ad5302.jpg";